var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestroyedAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5C5.11667 7.5 5.21458 7.46042 5.29375 7.38125C5.37292 7.30208 5.4125 7.20417 5.4125 7.0875C5.4125 6.97083 5.37292 6.87292 5.29375 6.79375C5.21458 6.71458 5.11667 6.675 5 6.675C4.88333 6.675 4.78542 6.71458 4.70625 6.79375C4.62708 6.87292 4.5875 6.97083 4.5875 7.0875C4.5875 7.20417 4.62708 7.30208 4.70625 7.38125C4.78542 7.46042 4.88333 7.5 5 7.5ZM4.6625 5.5875H5.4125V2.425H4.6625V5.5875ZM5 10C4.31667 10 3.67083 9.86875 3.0625 9.60625C2.45417 9.34375 1.92292 8.98542 1.46875 8.53125C1.01458 8.07708 0.65625 7.54583 0.39375 6.9375C0.13125 6.32917 0 5.67917 0 4.9875C0 4.30417 0.13125 3.65833 0.39375 3.05C0.65625 2.44167 1.01458 1.9125 1.46875 1.4625C1.92292 1.0125 2.45417 0.65625 3.0625 0.39375C3.67083 0.13125 4.32083 0 5.0125 0C5.69583 0 6.34167 0.13125 6.95 0.39375C7.55833 0.65625 8.0875 1.0125 8.5375 1.4625C8.9875 1.9125 9.34375 2.44167 9.60625 3.05C9.86875 3.65833 10 4.30833 10 5C10 5.68333 9.86875 6.32917 9.60625 6.9375C9.34375 7.54583 8.9875 8.07708 8.5375 8.53125C8.0875 8.98542 7.55833 9.34375 6.95 9.60625C6.34167 9.86875 5.69167 10 5 10Z",
    fill: "#DD5E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestroyedAsset);
export default __webpack_public_path__ + "static/media/destroyed-asset.99d49f9a6528e47ea78efa1f6013133c.svg";
export { ForwardRef as ReactComponent };